import TourTooltip from 'elements/tooltip/TourTooltip'
import { TourConfigType } from 'persistentContent/tours/types'
import { useTranslate } from 'ra-core'
import { FC } from 'react'

const StepTooltip: FC = (props) => {
  const translate = useTranslate()
  return (
    <TourTooltip
      title={translate('Ask Ada Anything')}
      subtext={translate(
        'Type your questions here. Ada can help you navigate, design systems, search for records, and answer questions about OpenSolar.'
      )}
      {...props}
    />
  )
}

const ChatInput: TourConfigType = {
  spotlights: [{ targetId: 'Ada-Chat-Input', autoScroll: true }],
  tooltips: [
    {
      targetId: 'Ada-Chat-Input',
      placement: 'top',
      component: StepTooltip,
      options: { style: { marginBottom: 10 } },
    },
  ],
}

export default ChatInput

